/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from "@mui/material";

import { Link, useLocation } from "react-router-dom";
import PATH from "../../router/paths";
import React, { useMemo } from "react";

const Footer = () => {
  const location = useLocation();

  const footerStyle = {
    width: "100%",
    backgroundColor: "primary.main",
    color: "white",
    padding: "1rem",
    textAlign: "center",
    position: "relative",
    bottom: 0,
  };

  const conditionalFooterStyle = useMemo(() => {
    if (
      location?.pathname?.includes("/survey-start") ||
      location?.pathname?.includes("/survey-form")
    ) {
      return {
        copyWrite: {
          ...footerStyle,
          backgroundColor: "secondary.main",
          color: "black",
        },
        links: {
          color: "black",
        },
      };
    } else {
      return {
        copyWrite: {
          ...footerStyle,
          backgroundColor: "primary.main",
          color: "white",
        },
        links: {
          color: "white",
        },
      };
    }
  }, [location?.pathname]);


  return (
    <Box sx={conditionalFooterStyle?.copyWrite}>
      <Typography variant="body1" component="p">
        &copy; {new Date().getFullYear()} OpinionStream. All rights reserved.
      </Typography>
      <Typography
        variant="body2"
        component="p"
        sx={{
          "& a": conditionalFooterStyle?.links,
        }}
      >
        <Link to={PATH.PRIVACY_POLICY} underline="hover">
          Privacy Policy
        </Link>
        {" | "}
        <Link to={PATH.CONTACT_SUPPORT} color="inherit" underline="hover">
          Contact Support
        </Link>
        {" | "}
        <Link to={PATH.COOKIES} color="inherit" underline="hover">
          Cookies
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
